import { NavigationItems } from 'app/shared/models/navigation-item.model';
import { FeaturedCard } from 'app/views/booking-detail/models/booking-details.model';

declare type NavigationItems = 'bookings' | 'invoices' | 'agency_credit' | 'groups' | 'cac' | 'manage_account';

export const StaticNavigationItems: Record<NavigationItems, FeaturedCard> = {
  bookings: {
    label: NavigationItems.Bookings.title,
    routerLink: NavigationItems.Bookings.url,
    icon: NavigationItems.Bookings.customIcon,
    hasOutput: false,
    isAllowed: false
  },
  invoices: {
    label: NavigationItems.Invoices.title,
    postActionRedirectUrl: NavigationItems.Invoices.url ?? '',
    targetBlank: true,
    icon: NavigationItems.Invoices.customIcon,
    hasOutput: false,
    isAllowed: false
  },
  agency_credit: {
    label: NavigationItems.AgencyCredit.title,
    routerLink: NavigationItems.AgencyCredit.url,
    icon: NavigationItems.AgencyCredit.customIcon,
    hasOutput: false,
    isAllowed: false
  },
  groups: {
    label: NavigationItems.Groups.title,
    icon: NavigationItems.Groups.customIcon,
    hasOutput: false,
    isAllowed: false
  },
  cac: {
    label: NavigationItems.Cac.title,
    icon: NavigationItems.Cac.customIcon,
    targetBlank: true,
    postActionRedirectUrl: '',
    hasOutput: false,
    isAllowed: false
  },
  manage_account: {
    label: NavigationItems.AccountManagement.title,
    targetBlank: true,
    icon: NavigationItems.AccountManagement.customIcon,
    hasOutput: false,
    isAllowed: false
  }
};
